function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useRef } from 'react';
/**
 * 미디어 업로드 기능을 위한 커스텀 훅
 */ export var useMediaUpload = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialMedia = options.initialMedia, initialMedia = _options_initialMedia === void 0 ? [] : _options_initialMedia;
    var _useState = _sliced_to_array(useState(initialMedia), 2), media = _useState[0], setMedia = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isMediaUploading = _useState1[0], setIsMediaUploading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), mediaUploadError = _useState2[0], setMediaUploadError = _useState2[1];
    var mediaInputRef = useRef(null);
    /**
   * 파일 선택 dialog 열기
   */ var triggerMediaUpload = function() {
        if (mediaInputRef.current) {
            mediaInputRef.current.click();
        }
    };
    /**
   * 미디어 파일 업로드 처리
   */ var handleMediaUpload = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var files, newMediaItems, allowedTypes, i, file, fileUrl, type;
            return _ts_generator(this, function(_state) {
                files = event.target.files;
                if (!files || files.length === 0) return [
                    2
                ];
                setIsMediaUploading(true);
                setMediaUploadError(null);
                try {
                    newMediaItems = [];
                    allowedTypes = [
                        'image/jpeg',
                        'image/png',
                        'image/gif',
                        'image/webp',
                        'video/mp4',
                        'video/webm'
                    ];
                    // 파일 처리
                    for(i = 0; i < files.length; i++){
                        file = files[i];
                        // 지원하는 파일 타입 확인
                        if (!allowedTypes.includes(file.type)) {
                            console.warn("지원하지 않는 파일 형식입니다: ".concat(file.type));
                            continue;
                        }
                        // 파일 크기 제한 (10MB)
                        if (file.size > 10 * 1024 * 1024) {
                            console.warn("파일 크기가 너무 큽니다: ".concat(file.name));
                            continue;
                        }
                        // 파일 URL 생성 (실제 구현에서는 서버에 업로드 후 URL을 받아야 함)
                        fileUrl = URL.createObjectURL(file);
                        // 미디어 타입 결정
                        type = file.type.startsWith('image/') ? 'image' : 'video';
                        // 새 미디어 아이템 추가
                        newMediaItems.push({
                            id: "temp-".concat(Date.now(), "-").concat(Math.random().toString(36).substring(2, 9)),
                            url: fileUrl,
                            type: type,
                            width: 0,
                            height: 0,
                            status: 'ready',
                            // tempFile 대신 file 속성에 할당
                            file: file
                        });
                    }
                    // 미디어 상태 업데이트
                    setMedia(function(prevMedia) {
                        return _to_consumable_array(prevMedia).concat(_to_consumable_array(newMediaItems));
                    });
                } catch (error) {
                    console.error('미디어 업로드 중 오류 발생:', error);
                    setMediaUploadError('미디어 업로드 중 오류가 발생했습니다.');
                } finally{
                    setIsMediaUploading(false);
                    // 파일 인풋 초기화
                    if (mediaInputRef.current) {
                        mediaInputRef.current.value = '';
                    }
                }
                return [
                    2
                ];
            });
        });
        return function handleMediaUpload(event) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * 미디어 제거 핸들러
   */ var handleRemoveMedia = function(index) {
        var updatedMedia = _to_consumable_array(media);
        // URL.revokeObjectURL을 사용하여 메모리 누수 방지
        if (updatedMedia[index].url && updatedMedia[index].url.startsWith('blob:')) {
            URL.revokeObjectURL(updatedMedia[index].url);
        }
        updatedMedia.splice(index, 1);
        setMedia(updatedMedia);
    };
    return {
        media: media,
        isMediaUploading: isMediaUploading,
        mediaUploadError: mediaUploadError,
        mediaInputRef: mediaInputRef,
        triggerMediaUpload: triggerMediaUpload,
        handleMediaUpload: handleMediaUpload,
        handleRemoveMedia: handleRemoveMedia,
        setMedia: setMedia
    };
};
